import * as math from "./math";
import * as text from "./text";
import * as file from "./file";
import * as array from "./array";
import * as error from "./error";
import * as date from "./date";
import * as adapters from "./adapters";
import * as predicates from "./predicates";
import * as utilities from "./utilities";
import * as notifications from "./notifications";

export const helpers = {
  math,
  text,
  file,
  utilities,
  array,
  error,
  date,
  adapters,
  predicates,
  notifications,
};
